import { render, staticRenderFns } from "./retrieve.vue?vue&type=template&id=c2f1419c&scoped=true"
import script from "./retrieve.vue?vue&type=script&lang=js"
export * from "./retrieve.vue?vue&type=script&lang=js"
import style0 from "./retrieve.vue?vue&type=style&index=0&id=c2f1419c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1419c",
  null
  
)

export default component.exports